import { Box, Image, Text, VStack } from '@skin-seoul/design-system';
import searchImage from '../assets/search.png';
export const ProductEmpty = () => {
  return <VStack width="100%" height="100%" gap="26px" alignItems="center" justifyContent="center" data-sentry-element="VStack" data-sentry-component="ProductEmpty" data-sentry-source-file="ProductEmpty.tsx">
      <Box boxSize="100px" data-sentry-element="Box" data-sentry-source-file="ProductEmpty.tsx">
        <Image src={searchImage.src} alt="No results found" width="100%" height="100%" objectFit="contain" data-sentry-element="Image" data-sentry-source-file="ProductEmpty.tsx" />
      </Box>

      <VStack gap={3} alignItems="center" width={{
      base: '258px',
      tablet: '100%'
    }} data-sentry-element="VStack" data-sentry-source-file="ProductEmpty.tsx">
        <Text textStyle="paragraph.small" fontWeight="medium" color="neutral.500" textAlign="center" data-sentry-element="Text" data-sentry-source-file="ProductEmpty.tsx">
          No close match found this time
        </Text>
        <Text textStyle="paragraph.small" fontWeight="regular" color="neutral.400" textAlign="center" data-sentry-element="Text" data-sentry-source-file="ProductEmpty.tsx">
          You can broaden your filters or choose a different product to compare.
        </Text>
      </VStack>
    </VStack>;
};